export default {
    loggedIn: state => state.loggedIn,
    user: state => state.user
  }